import {Inject, Injectable} from '@angular/core';
import {MM_CONFIG, MMConfig} from './mm.config';
import {REPORTING_CONFIG, ReportingConfig} from '@docma-mm-core/config/reporting.config';
import {EXPORT_CONFIG, ExportConfig} from '@docma-mm-core/config/export-config';
import {FILE_CONFIG, FileConfig} from '@docma-mm-core/config/file-config';

@Injectable()
export class ConfigService {

  constructor(@Inject(MM_CONFIG) private mmConfig,
              @Inject(REPORTING_CONFIG) private reportingConfig,
              @Inject(EXPORT_CONFIG) private exportConfig: ExportConfig,
              @Inject(FILE_CONFIG) private fileConfig: FileConfig) {

    console.log('ctor ConfigService');
  }

  getMmConfig(): MMConfig {
    return this.mmConfig;
  }

  getReportingConfig(): ReportingConfig {
    return this.reportingConfig;
  }

  getExportConfig(): ExportConfig {
    return this.exportConfig;
  }

  getFileConfig(): FileConfig {
    return this.fileConfig;
  }
}
